import { render, staticRenderFns } from "./PasswordTemplate.vue?vue&type=template&id=5fda19c7&scoped=true&"
import script from "./PasswordTemplate.vue?vue&type=script&lang=js&"
export * from "./PasswordTemplate.vue?vue&type=script&lang=js&"
import style0 from "./PasswordTemplate.vue?vue&type=style&index=0&id=5fda19c7&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fda19c7",
  null
  
)

export default component.exports